<div class="row">
  <div class="col-9"></div>
  <div class="col-3" (click)="closeDialog()" style="text-align: right;">
    <i class="material-icons" style="cursor: pointer; font-size: 28px;">
      cancel
    </i>
  </div>
</div>
<div class="row">
  <div class="col">
    <label>We cannnot get the price because there are mulliple price under your date range Plese check follwing table to
      apply respective date range</label>
  </div>
</div>
<div class="row" *ngFor="let product of product_list; let index=index">
  <div class="col">
    <label style="font-weight: bold;">{{product}}</label>
  </div>
  <table class="table table-bordered table-hover" id="printTable">
    <thead style="background: bisque;" *ngIf="index == 0">
      <tr>
        <th>Product</th>
        <th>MRP</th>
        <th>Start Date</th>
        <th>End Date</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let price of product_data[product]">
        <td>{{price['product_name']}}</td>
        <td>{{price['mrp']}}</td>
        <td>{{price['start_date'] | date}}</td>
        <td>{{price['end_date'] | date}}</td>
      </tr>
    </tbody>
  </table>
</div>
